import React from 'react';

import { Layout } from 'antd';

const Footer = () => {
  return (
    <Layout.Footer style={{ textAlign: 'center' }}>JTP-MVV ©2021</Layout.Footer>
  );
};

export default Footer;
